<template>
  <v-select
    :model-value="modelValue"
    :items="roleOptions"
    item-title="label"
    item-value="value"
    label="Papel validador"
    :disabled="disabled"
    :error="error"
    :error-messages="error ? 'Selecione um papel validador' : undefined"
    density="compact"
    variant="outlined"
    hide-details="auto"
    style="width: 250px; min-width: 250px"
    bg-color="white"
    data-testid="approval-role-selector"
    @update:model-value="(val) => emit('update:modelValue', val)"
  />
</template>

<script setup lang="ts">
import { VALIDATION_ROLE_OPTIONS } from '@/utils/exceptionality'
import type { ValidationRole } from '@/types/approval-flow.types'

interface Props {
  modelValue: ValidationRole | null
  disabled?: boolean
  error?: boolean
}

withDefaults(defineProps<Props>(), {
  disabled: false,
  error: false
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: ValidationRole | null): void
}>()

const roleOptions = VALIDATION_ROLE_OPTIONS
</script>
